import { useMemo } from 'react';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import { LIGHT_THEME } from '@rsos/theme/constants';
import {
  ALERTS,
  ALERTS_DARK,
  TF911_LIGHT,
  TF911_DARK,
  RCS911_LIGHT,
  RCS911_DARK,
} from '../constants/talkjsThemes';

/**
 * Get the TalkJS UI theme that corresponds to the Portal theme.
 * @param {Boolean} isTF911 - Is the theme used for TF911?
 * @returns String
 */
const useTalkJSTheme = (isTF911 = false, isRCS911 = false) => {
  const themeName = useSelectedTheme();

  return useMemo(() => {
    if (isRCS911) {
      return themeName === LIGHT_THEME ? RCS911_LIGHT : RCS911_DARK;
    }

    if (themeName === LIGHT_THEME) {
      return isTF911 ? TF911_LIGHT : ALERTS;
    }

    if (isTF911) {
      return TF911_DARK;
    }

    return ALERTS_DARK;
  }, [isTF911, themeName, isRCS911]);
};

export default useTalkJSTheme;
